import { CodeLangConfig, SupportedCodeLang } from './code-lang.types';

const SUPPORTED_CODE_LANGS = ['python', 'arduino'] as const;

const CODE_LANG = (<T extends Record<string, SupportedCodeLang>>(obj: T) => obj)({
  PYTHON: 'python',
  ARDUINO: 'arduino',
} as const);

const DEFAULT_CODE_LANG: SupportedCodeLang = CODE_LANG.PYTHON;

const CODE_LANG_CONFIG = (<T extends Record<SupportedCodeLang, CodeLangConfig>>(config: T) => config)({
  [CODE_LANG.PYTHON]: {
    generatorName: 'Python',
    fileExtension: '.py',
    commentSymbol: '#',
    storagePrefix: 'py-',
    toolboxPath: 'assets/blockly/toolbox/python/',
    displayLabel: 'Python Script'
  },
  [CODE_LANG.ARDUINO]: {
    generatorName: 'Arduino',
    fileExtension: '.ino',
    commentSymbol: '//',
    storagePrefix: 'ar-',
    toolboxPath: 'assets/blockly/toolbox/arduino/',
    displayLabel: 'Arduino Sketch'
  }
});

export {
  SUPPORTED_CODE_LANGS,
  CODE_LANG,
  DEFAULT_CODE_LANG,
  CODE_LANG_CONFIG
};
